import request from '/@common/utils/request';

//查询知识库
export function userPage(data: object) {
	return request({
		url: '/api/knowledge-base/userPage',
		method: 'post',
		data,
	});
}
//创建知识库
export function createKnowledge(data: object) {
	return request({
		url: '/api/knowledge-base/createKnowledge',
		method: 'post',
		data,
	});
}
//编辑知识库
export function deleteKnowledge(data: object) {
	return request({
		url: '/api/knowledge-base/deleteKnowledge',
		method: 'post',
		data,
	});
}
//删除知识库
export function editKnowledge(data: object) {
	return request({
		url: '/api/knowledge-base/editKnowledge',
		method: 'post',
		data,
	});
}

//根据文件ID获取文件信息
export function getById(id: string) {
	return request({
		url: '/api/knowledge-file/file/getById/'+id,
		method: 'get',
	});
}
//文件批量上传
export function fileUploadBatch(data: object) {
	return request({
		url: '/api/knowledge-file/file/uploadBatch',
		method: 'post',
		data,
		headers:{
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
}

// 获取相关参数
export function getDialogueParam(appId: number | string) {
	return request({
		url: '/api/conversation/getDialogueParam/' + appId,
		method: 'get',
	});
}
// [知识库问答] @指令列表
export function listKnowledgeBasePrompt(params: object) {
	return request({
		url: '/api/dialogue/listKnowledgeBasePrompt',
		method: 'get',
		params
	});
}
// [知识库问答] @指令列表 文件文件夹
export function knowledgeAt(params: object) {
	return request({
		url: '/api/knowledge-base/knowledgeAt',
		method: 'get',
		params
	});
}

// [智能问答] @指令列表
export function listChatBasePrompt(params: object) {
	return request({
		url: '/api/app/v3/fuzzyMatching',
		method: 'get',
		params
	});
}
// [智能问答] 知识库推荐问答
export function listRecommendQuestion(data: object) {
	return request({
		url: '/api/dialogue/listRecommendQuestion/',
		method: 'post',
		data
	});
}
export function roleCreateKnowledge(data: object) {
	return request({
		url: '/api/knowledge-file/createKnowledge',
		method: 'post',
		data
	});
}
export function uploadBatch(data: object) {
	return request({
		url: '/api/knowledge-file/file/uploadBatch',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}
export function fileList(id: string) {
	return request({
		url: `/api/knowledge-file/fileList/${id}`,
		method: 'get',
	});
}
export function urlUpload(data: object) {
	return request({
		url: `/api/knowledge-file/file/urlUpload`,
		method: 'post',
		data
	});
}
export function deleteKnowledgeId(id:string) {
	return request({
		url: `/api/knowledge-file/file/delete/${id}`,
		method: 'delete',
	});
}
export function getFileTypes() {
	return request({
		url: `/api/dialogue/getFileTypes`,
		method: 'get',
	});
}
export function articleSaveKnowledge(data:object) {
	return request({
		url: `file/api/knowledge-file/articleSaveKnowledge`,
		method: 'post',
		data
	});
}